import i18n from '~/i18n'

// Stored field types stay enums such as SELECT. This returns the name shown in the type picker.
export default function fieldTypeLabel(fieldType) {
    const type = String(fieldType || '').toUpperCase()
    if (!type) return 'N/A'
    const key = `fieldTypes.${type}.label`
    // Missing keys are rewritten to their last segment, so compare against the key itself is not enough.
    if (!i18n.exists(key)) return type
    return i18n.t(key)
}

// A multi-select form control can only store a multi-select custom field.
export function forcedNewFieldType({ selectedType, allowMulti } = {}) {
    const allowMultiple = allowMulti === '1' || allowMulti === 1 || allowMulti === true
    const selected = String(selectedType || '').toUpperCase()
    if (allowMultiple || selected === 'MULTISELECT') return 'MULTISELECT'
    return undefined
}
